<template>
  <div class="report-detail-container">
    <van-nav-bar
      :title="navTitle"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333"/>
      </template>
    </van-nav-bar>
    <div class="content-area">
      <van-form class="report-detail">
        <van-field 
          :value="reportDetailForm.modelName" 
          label="流程名称："  
          readonly
        />
        <van-field 
          :value="reportDetailForm.submitTime" 
          label="提交时间：" 
          readonly 
        />
        <van-field 
          :value="reportDetailForm.approvalNo" 
          label="审批编号："  
          readonly 
        />
        <div v-for="item in fieldList" :key="item.initiatorId">
          <template v-if="item.fieldType === 'textarea'">
            <van-field 
              :value="item.value" 
              :label="`${item.fieldName}：`"  
              type="textarea" 
              readonly 
              :autosize=" { minHeight: 100, maxHeight: 200 }"
            />
          </template>  
          <template v-else>
            <van-field 
              :value="item.value" 
              :label="`${item.fieldName}：`"  
              readonly 
            />
          </template>  
        </div>
      </van-form>
      <div class="file-list-wrapper" v-if="fileListInfo.fileList.length">
        <div class="file-list-title">{{ fileListInfo.fileLabel }}</div>
        <ul class="file-list">
          <li v-for="item in fileListInfo.fileList" :key="item.fieldNo" class="file-item">
            <div class="file-detail">
              <img :src="fileImg" alt="" class="file-icon">
              <div class="file-des">
                <div class="file-name">{{ item.name }}</div>
                <div class="file-size">{{ formatSize(item.size, 2) }}</div>
              </div>
            </div>
            <div class="btn-group">
              <div class="sacn-btn" @click="preview(item.url)">预览</div>
              <div class="download-btn" @click="uploadFile(item)">下载</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getApproveInfo } from "@/axios/services"
import fileImg from '@/assets/file@2x.png'
import { Toast } from 'vant'
import { formatSize } from "../utils";
import dayjs from "dayjs";
export default {
  data () {
    return {
      fileImg,
      reportDetailForm: {
        modelName: "",
        submitTime: "",
        approvalNo: "",
      },
      fieldList: [],
      fileListInfo: {
        fileList: [],
        fileLabel: "",
      }
    }
  },
  created () {
    this.queryApproveInfo()
  },
  methods: {
    formatSize,
    onClickLeft () {
      this.$router.back()
    },
    async queryApproveInfo () {
      let [error, data] = await this.to(getApproveInfo({
        instanceId: this.instanceId,
        draftFlag: 1
      }))

      if (error) {
        return Toast.fail(error)
      }

      if (data) {
        let { modelName, approvalNo, initiator, fields} = data
        modelName && (this.reportDetailForm.modelName = modelName)
        approvalNo && (this.reportDetailForm.approvalNo = approvalNo)
        initiator?.createDate && (this.reportDetailForm.submitTime = dayjs(initiator?.createDate).format('YYYY-MM-DD HH:mm:ss'))
        this.fieldList = (fields || []).filter(item => {
          return item.fieldType !== "upload"
        })
        let fileInfo = (fields || []).find(item => {
          return item.fieldType === "upload"
        })
        this.fileListInfo.fileLabel = fileInfo?.fieldName
        this.fileListInfo.fileList = fileInfo?.value
      }
      
    },
    preview(url) {
      window.location.href = "jsToOc://fujianJump?url=" + url;
    },
    uploadFile (item) {
      let isAndroid = this.getPhoneType() === "Android"
      if (isAndroid) {
        window.attachmentDownload.downloadFile(
          item.url,
          item.name,
          item.suffix
        );
      } else {
        window.webkit.messageHandlers.attachmentDownload.postMessage({
          url: item.url,
          name: item.name,
          suffix: item.suffix
        });
      }
    },
    getPhoneType() {
      const u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
        return "Android"
      }
      if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return "Ios"
      }
    },
    to (promise, errorFirst = true) {
      return promise.then(data => {
        let { code, msg, data: res } = data.data
        if (code == 0) {
          return errorFirst ? [null, res] : [null, res]
        } else {
          Toast.fail(msg)
          return errorFirst ? [null, null] : [null, null]
        }
      }).catch(err => {
        return errorFirst ? [err, null] : [null, err]
      }) 
    }
  },
  computed: {
    instanceId () {
      return this.$route.query?.instanceId
    },
    navTitle () {
      return `${this.$route.query?.initiatorName}的汇报`
    }
  }
}
</script>

<style scoped>
.report-detail {
  padding: 16px;
}
.content-area {
  height: calc(100vh - 48px);
  overflow-y: scroll;
}
.file-list-wrapper {
  padding: 0 16px;
}
.file-list-title {
  background-color: #fff;
  font-size: 16px;
  font-weight: 600;
  padding: 16px;
}
.file-list {
  background-color: #fff;
}
.file-item {
  display: flex;
  align-items: center;
  padding: 0 16px 16px 16px;
  justify-content: space-between;
}
.file-icon {
  width:24px;
  height:21px;
  margin-right: 8px;
}
.file-detail, .btn-group {
  display: flex;
  align-items: center;
}
.sacn-btn, .download-btn {
  color:#1584ff;
  font-size: 12px;
  /* padding: 6px 16px; */
  width: 60px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #1584ff;
  border-radius:4px;
}
.sacn-btn {
  margin-right: 10px;
}

.file-des {
  max-width: 80%;
}

.flie-name {
  color:#424242;
  font-size:14px;
}

.file-size {
  color:#999999;
  font-size:12px;
}
</style>